import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { type FC } from 'react';
import { convertSecondsToTime } from 'utils/timeHelper';
import { format } from 'date-fns';
import common from 'constants/common';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useCheckRoleAccess } from 'infrastructure/hooks';

import s from './styles.module.scss';

import type { Res as IModuleData } from '../../hooks';

interface Props {
  loading: boolean;
  addLoading: boolean;
  today: Date;
  rpmData?: IModuleData;
  ccmData?: IModuleData;
  onAdd: () => void;
}

const CombinedInteractiveTimeMobile: FC<Props> = ({
  addLoading,
  loading,
  today,
  ccmData,
  rpmData,
  onAdd,
}) => {
  const { t } = useTranslation();
  const { isReadOnlyRole } = useCheckRoleAccess();
  const isSplitView = ccmData && rpmData;

  return (
    <div className={s.combined} id="interaction-time">
      <BaseSpinWrapper spinning={loading}>
        <div className={s.wrapper} data-cy="interactive-time-block">
          <div className={s['title-wrapper']}>
            <h4 className={s.title}>{t('controls.interactiveTime')}</h4>
          </div>
          <div className={s.divider} />
          <div className={s.body}>
            <div className={s['module-title-wrapper']}>
              {rpmData && (
                <div className={s['module-title']}>{t('labels.rpm')}</div>
              )}
              {ccmData && (
                <div className={s['module-title']}>{t('labels.ccm')}</div>
              )}
            </div>
            <div className={s.divider} />
            <div className={s.modules}>
              {rpmData && (
                <div
                  className={classNames(s['module-wrapper'], {
                    [s['without-border']]: !isSplitView,
                  })}
                >
                  <div className={s['module-item']}>
                    <p className={s['module-time-title']}>
                      {t('controls.clinic')}
                    </p>
                    <div
                      className={s['module-time']}
                      data-cy="rpm-clinic-interactive-time"
                    >
                      {convertSecondsToTime(rpmData?.clinicTime)}
                    </div>
                  </div>
                  <div className={s['module-item']}>
                    <p className={s['module-time-title']}>
                      {t('controls.total')}
                    </p>
                    <div
                      className={s['module-time']}
                      data-cy="rpm-total-interactive-time"
                    >
                      {convertSecondsToTime(rpmData?.totalTime)}
                    </div>
                  </div>
                </div>
              )}
              <p className={s['module-month']}>
                {format(today, common.dateFormats.interactiveTime)}
              </p>
              {ccmData && (
                <div className={s['module-wrapper']}>
                  <div className={s['module-item']}>
                    <p className={s['module-time-title']}>
                      {t('controls.clinic')}
                    </p>
                    <div
                      className={s['module-time']}
                      data-cy="ccm-clinic-interactive-time"
                    >
                      {convertSecondsToTime(ccmData?.clinicTime)}
                    </div>
                  </div>
                  <div className={s['module-item']}>
                    <p className={s['module-time-title']}>
                      {t('controls.total')}
                    </p>
                    <div
                      className={s['module-time']}
                      data-cy="ccm-total-interactive-time"
                    >
                      {convertSecondsToTime(ccmData?.totalTime)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={s['btn-wrapper']}>
            <BaseButton
              label={t('labels.addTime')}
              dataCy="add-manual-time-button"
              onClick={onAdd}
              loading={addLoading}
              disabled={isReadOnlyRole || addLoading}
            />
          </div>
        </div>
      </BaseSpinWrapper>
    </div>
  );
};

export default CombinedInteractiveTimeMobile;
